/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerGetDownloadUrlQueryResponse, ComparisonsControllerGetDownloadUrlPathParams, ComparisonsControllerGetDownloadUrl400, ComparisonsControllerGetDownloadUrl401, ComparisonsControllerGetDownloadUrl403, ComparisonsControllerGetDownloadUrl404 } from "../../models/comparisonsController/ComparisonsControllerGetDownloadUrl";

function getComparisonsControllerGetDownloadUrlUrl(id: ComparisonsControllerGetDownloadUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/comparisons/${id}/download-url` as const }  
  return res
}

/**
 * @summary Get presigned download URL for comparison PDF
 * {@link /api/v1/comparisons/:id/download-url}
 */
export async function comparisonsControllerGetDownloadUrl(id: ComparisonsControllerGetDownloadUrlPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ComparisonsControllerGetDownloadUrl400 | ComparisonsControllerGetDownloadUrl401 | ComparisonsControllerGetDownloadUrl403 | ComparisonsControllerGetDownloadUrl404>, unknown>({ method : "GET", url : getComparisonsControllerGetDownloadUrlUrl(id).url.toString(), ... requestConfig })  
  return res.data
}